<!-- <deletemodal id="customer-tabs" [deleteModal]="activateDeactivatePopup"></deletemodal> -->
<deletemodal id="customer-tabs" [deleteModal]="clearPopup"></deletemodal>
 
<!-- popup for addnew ticketSubType -->
<modal #createSubTicketModal class="createSubTicketModal-header">
    <modal-header>
        <div *ngIf="!isUpdate" class="color-blue">{{'config-system.ADD NEW TICKET SUBTYPE' |translate}}</div>
        <div *ngIf="isUpdate" class="color-blue">{{'config-system.MANAGE SUBTYPE' |translate}}</div>
    </modal-header>
    <modal-content>
        <form *ngIf="subtypeForm" [formGroup]="subtypeForm" (ngSubmit)="onSubmit(subtypeForm.valid)" style="margin-left: -15px;width: 104%;"
            class="col-xs-12  ticket-color-validation" novalidate>
            <div class=" form-horizontal">
                <div class="row">
                    <label for="operatingCountryId" class="col-sm-3 col-form-label">{{'config-system.Operating Country' |translate |translateKey}}</label>
                    <div class="col-sm-6 floating-input">
                        <select tabindex="0" id="autofocus-modal-element" class="form-control ng-pristine ng-invalid ng-touched"  formControlName="operatingCountryId" (change)="getTicketTypesBasedonOperatingCountry()" [attr.disabled]="!isUpdate?null:''">
                            <option *ngIf = "isCountriesLoading" value="">{{'department-system.Loading...' |translate |translateKey}}</option>
                            <option value="">{{'config-system.--Select--' |translate}}</option>
                            <option *ngFor="let country of operatingCountries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
                        </select>             
                        <div class="alert-msg" *ngIf="!subtypeForm.controls['operatingCountryId'].valid  && subtypeForm.controls['operatingCountryId'].hasError('required') && (subtypeForm.controls['operatingCountryId'].touched || isSubmitted)">
                            {{'validation-message.required'|translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label for="ticketType" class="col-sm-3 col-form-label">{{'config-system.Ticket Type Name' |translate}}</label>
                    <div class="col-sm-6 floating-input">
                    <select tabindex="0" class="form-control"  formControlName="ticketType" [attr.disabled]="!isTicketTypeExist?null:''">
                            <option value="">{{'config-system.--Select--' |translate}}</option>
                            <option *ngFor="let ticketType of ticketTypes" [ngValue]="ticketType.id">{{ticketType.value}}</option>
                     </select>
                        
                        <div class="alert-msg" *ngIf="!subtypeForm.controls['ticketType'].valid  && subtypeForm.controls['ticketType'].hasError('required') && (subtypeForm.controls['ticketType'].touched || isSubmitted)">
                            {{'validation-message.required'|translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label for="ticketSubType" class="col-sm-3 col-form-label">{{'config-system.Ticket SubType' |translate}}</label>
                    <div class="col-sm-6 floating-input">
                        <input  id="tkttypename-focus" tabindex="0" type="text" class="form-control" placeholder="{{'config-system.Ticket SubType' |translate}}" formControlName="ticketSubType">
                        <div class="alert-msg" *ngIf="!subtypeForm.controls['ticketSubType'].valid  && subtypeForm.controls['ticketSubType'].hasError('required') && (subtypeForm.controls['ticketSubType'].touched || isSubmitted)">
                            {{'validation-message.required'|translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label for="" class="col-sm-3 col-form-label"></label>
                    <div class="col-sm-6">                        
                        <input tabindex="0" type="checkbox"  id="status" checked="true" formControlName ="ticketSubTypeStatus" [attr.disabled]="isUpdate && deactivateSubTypePermission?null:''"/> <label>{{'config-system.Active' |translate}}</label>
                    </div>
                   
                </div>                
            </div>         
            <div class="pull-right pad-r-8">
                <button *ngIf="!isUpdate"  class="btn blue-button" tabindex="0" type="submit">
                    {{'config-system.ADD' |translate}}
                </button>
                <button *ngIf="isUpdate" class="btn blue-button" tabindex="0" type="submit">
                    {{'config-system.UPDATE' |translate}}
                </button>
                
                <button  class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                {{'config-system.CANCEL' |translate}}
                </button>                    
            </div>
        </form>
    </modal-content>
    <modal-footer>

    </modal-footer>
</modal>
<!-- end -->
<div class="tab-content">
    <!--<form [formGroup]="subtypeForm" novalidate (ngSubmit)="onSearch()" class="">-->
        <div role="tabpanel" class="tab-pane fade in active  padd-top-0  center-75per-width" id="users">
             <section class="mt-minus-36">
                <div class="color-blue">                    
                    <h2></h2>                    
                </div>
            </section>             
            <section>                        
                <div class="clearfix text-right">
                    <div class="col-md-12 left-padding-0">
                        <div class="row">
                            <div class="col-md-3">
                                <select tabindex="0"  id="autofocus-element" class="form-control ng-pristine ng-invalid ng-touched" autofocus [(ngModel)]="operatingCountry">
                                    <option *ngIf = "isCountriesLoading" [value]="0">Loading...</option>
                                    <option [value]="0">{{'config-system.Operating Country' |translate}}</option>

                                    <option *ngFor="let country of operatingCountries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
                                </select>                                
                            </div>
                            <div class="col-md-3 floating-input floatLabelContainer">
                                <input tabindex="0" type="text" float-label class="form-control"   [(ngModel)]="ticketType" placeholder="{{'config-system.Ticket Type Name' |translate}}"
                                (keyup.enter)="onSearch()" />
                            </div>
                            <div class="col-md-3 floating-input floatLabelContainer">
                                    <input type="text" float-label class="form-control" [(ngModel)]="ticketSubType" placeholder="{{'config-system.Ticket SubType Name' |translate}}"
                                    (keyup.enter)="onSearch()" />
                            </div>
                            <div class="col-md-3"></div>
                        </div>
                    </div>
                    <div class="col-md-12  no-padding">
                        <button id="search-button" class="btn blue-button" tabindex="0" type="button"  (click)="onSearch()">{{'config-system.Search' |translate}}</button>
                        <button class="btn grey-button" tabindex="0" type="button" (click)="clearFields()">{{'config-system.Cancel' |translate}}</button>  
                        <div class="clearfix text-left font14">
                            <a autofocus="" tabindex="0" id="processor-btn"  *ngIf="creatSubTypePermission"  (click)="openCreateSubTicketModal()">
                                <span class="glyphicon glyphicon-plus"></span> &nbsp;&nbsp;{{'config-system.ADD NEW' |translate}}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <!--/Body Section End-->
            <!-- table -->
        
            <div class=" clearfix">
                <table class="table table-hover table-striped custab">
                    <thead>
                        <tr>
                            <th (click)="sort('ticketTypeId')" class="pointer">{{'config-system.Ticket Type Name' |translate}}&nbsp;
                                <i class="fa" [ngClass]="{'fa-sort': sortOrder != 'ticketTypeId', 'fa-sort-asc': (sortOrder == 'ticketTypeId' && !isDesc), 'fa-sort-desc': (sortOrder == 'ticketTypeId' && isDesc) }"
                                    aria-hidden="true"> </i>
                            </th>
                            <th (click)="sort('value')" class="pointer">{{'config-system.Ticket SubType Name' |translate}}&nbsp;
                                    <i class="fa" [ngClass]="{'fa-sort': sortOrder != 'value', 'fa-sort-asc': (sortOrder == 'value' && !isDesc), 'fa-sort-desc': (sortOrder == 'value' && isDesc) }"
                                        aria-hidden="true"> </i>
                            </th>

                            <th (click)="sort('operatingCountry')" class="pointer">{{'config-system.Operating Country' |translate}}&nbsp;
                                <i class="fa" [ngClass]="{'fa-sort': sortOrder != 'operatingCountry', 'fa-sort-asc': (sortOrder == 'operatingCountry' && !isDesc), 'fa-sort-desc': (sortOrder == 'operatingCountry' && isDesc) }"
                                    aria-hidden="true"> </i>
                            </th>
                            <th  (click)="sort('rowStatus')" class="pointer">{{'config-system.Status' |translate}}&nbsp;
                                <i class="fa" [ngClass]="{'fa-sort': sortOrder != 'rowStatus', 'fa-sort-asc': (sortOrder == 'rowStatus' && !isDesc), 'fa-sort-desc': (sortOrder == 'rowStatus' && isDesc) }"
                                    aria-hidden="true"> </i>
                            </th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let subType of ticketSubTypes | paginate: {  id: 'ticket-subtype-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                            <!-- <td *ngIf="isTicketView"><a [ngClass]="{'color-warning':ticket.overDueTicket}" tabindex="0" (keyup.enter)="goToViewTicket(ticket.id,ticket.ticketNumber,true)"
                                    (click)="goToViewTicket(ticket.id,ticket.ticketNumber,true)">{{ticket.ticketType}}</a></td> -->
                            <td *ngIf="subType.operatingCountryName!==null && editSubTypePermission"><a (click)="editSubtype(subType.id)">{{subType.ticketTypeName}}</a></td>
                            <!-- <td *ngIf="!subType.operatingCountryName==null && editSubTypePermission===false">{{subType.ticketTypeName}}</td> -->
                            <td *ngIf="subType.operatingCountryName==null && editSubTypePermission">{{subType.ticketTypeName}}</td>
                            <td *ngIf="subType.operatingCountryName==null && !editSubTypePermission">{{subType.ticketTypeName}}</td>
                            <td *ngIf="subType.operatingCountryName && !editSubTypePermission">{{subType.ticketTypeName}}</td>

                                <td>{{subType.name}}</td>
                            <td *ngIf="subType.operatingCountryName">{{subType.operatingCountryName}}</td>
                            <td *ngIf="!subType.operatingCountryName">ALL </td>                                                      
                            <td>{{rowStatus[subType.rowStatusId]}}</td>                                
                        </tr>
                            <!-- <td *ngIf="subType.operatingCountryName!==null && test===true"><a (click)="editSubtype(subType.id)">{{subType.ticketTypeName}}</a></td>
                        <td *ngIf="subType.operatingCountryName === null && test===true">{{subType.ticketTypeName}}</td> 
                            -->
                    </tbody>
                    <tbody *ngIf="pageCount===0">
                        <tr align="center">                                
                            <td colspan=4>{{'store-user.No records found' |translate}}</td>
                        </tr>
                    </tbody>
                </table>
                {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
                <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>
            </div>
        </div>
    <!--</form>--> 
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/configuration/ticketSubType.component.html